import React from 'react';
import { YStack, Text, XStack, Circle } from 'tamagui';
import { tokens } from 'tamagui-config';

interface PinIndicatorProps {
  currentCount: number;
  totalCount: number;
  pinError: string | null;
}

export const PinIndicator: React.FC<PinIndicatorProps> = ({
  currentCount,
  totalCount,
  pinError,
}) => {
  const circles = Array.from({ length: totalCount }, (_, index) => index < currentCount);

  return (
    <YStack alignItems="center">
      <XStack gap="$4">
        {circles.map((isFilled, index) => (
          <Circle
            key={index}
            width={32}
            height={32}
            backgroundColor={isFilled ? tokens.color.white12 : tokens.color.transparent}
            borderWidth={2}
          />
        ))}
      </XStack>
      <Text
        height={24}
        fontFamily="$body"
        fontSize="$4"
        fontWeight="$4"
        color={pinError ? tokens.color.warningRed : tokens.color.transparent}
        marginTop="$2">
        {pinError || ''}
      </Text>
    </YStack>
  );
};
